export default __webpack_public_path__ + "static/media/kid10.aa1d38db.jpg";